function isPayloadAction(action) {
  return action.payload !== undefined;
}

export function createAction (type, payload) {
  const action = { type, payload };
  return isPayloadAction(action) ? action : { type };
}
